import React from "react";

export default function Terms(props) {
  return <div>{`Terms for ${props.appName}`}</div>;
}
